module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-office-forms ccm-page"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), _c('Header'), (!_vm.loading) ? _c('main', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.props.acf.you_want_add_second_title_) ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.title_second)
    }
  })]) : _c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "page-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  })])])]), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "ccm-faq-container"
  }, [_c('div', {
    staticClass: "ccm-faq-block-links"
  }, _vm._l((_vm.props.acf.add_faqs), function(faqcontent, index1) {
    return _c('a', {
      attrs: {
        "href": '#32' + index1
      },
      domProps: {
        "innerHTML": _vm._s(faqcontent.title)
      }
    })
  })), _c('div', {
    staticClass: "ccm-faq-block-entries"
  }, _vm._l((_vm.props.acf.add_faqs), function(faqcontent, index1) {
    return _c('div', {
      staticClass: "faq-entry-content"
    }, [_c('a', {
      attrs: {
        "id": '32' + index1
      }
    }), _c('h3', {
      domProps: {
        "innerHTML": _vm._s(faqcontent.title)
      }
    }), _c('div', {
      domProps: {
        "innerHTML": _vm._s(faqcontent.content)
      }
    })])
  }))])])])])]) : _vm._e(), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a016b69","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/faqs/faqs.pug
// module id = 559
// module chunks = 1